import { getId } from 'conversations-message-history/senders/operators/getters';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export const chooseInboxChangeMessage = ({
  activeAgentId,
  auditAgentSender,
  auditAgentName,
  currentInboxId,
  destinationInboxId,
  destinationInboxName
}) => {
  const activeAgentIsMover = auditAgentSender && activeAgentId === getId(auditAgentSender);
  const currentInboxIsDestination = currentInboxId === destinationInboxId;
  if (activeAgentIsMover) {
    // you moved this message
    if (currentInboxIsDestination) {
      // you moved this message to this inbox

      return /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: 'conversations-thread-view.thread-move-to-inbox.activeAgentMover.currentInbox'
      });
    } else {
      // you moved this conversation to another inbox
      if (destinationInboxName) {
        return /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: 'conversations-thread-view.thread-move-to-inbox.activeAgentMover.namedInbox',
          options: {
            destinationInboxName
          }
        });
      } else {
        return /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: 'conversations-thread-view.thread-move-to-inbox.activeAgentMover.anotherInbox'
        });
      }
    }
  } else if (auditAgentName) {
    // some agent moved this conversations
    if (currentInboxIsDestination) {
      // some agent moved this conversation to this inbox

      return /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: 'conversations-thread-view.thread-move-to-inbox.auditAgentSender.currentInbox',
        options: {
          auditAgentName
        }
      });
    } else {
      if (destinationInboxName) {
        return /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: 'conversations-thread-view.thread-move-to-inbox.auditAgentSender.namedInbox',
          options: {
            destinationInboxName,
            auditAgentName
          }
        });
      } else {
        return /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: 'conversations-thread-view.thread-move-to-inbox.auditAgentSender.anotherInbox',
          options: {
            auditAgentName
          }
        });
      }
    }
  } else {
    // unknown agent moved this conversations
    if (currentInboxIsDestination) {
      // this conversation was moved to the current inbox
      return /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: 'conversations-thread-view.thread-move-to-inbox.unknownAgentSender.currentInbox'
      });
    } else {
      if (destinationInboxName) {
        return /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: 'conversations-thread-view.thread-move-to-inbox.unknownAgentSender.namedInbox',
          options: {
            destinationInboxName
          }
        });
      } else {
        return /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: 'conversations-thread-view.thread-move-to-inbox.unknownAgentSender.anotherInbox'
        });
      }
    }
  }
};